module.exports = __webpack_public_path__ + "img/loans.4d79a10.svg";